import { Injectable, ViewContainerRef, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";

import { RejectAndConfirmDialogComponent } from "./reject-confirm-dialog.component";

@Injectable()
export class RejectAndConfirmDialogService {
  private dialog = inject(MatDialog);

  public clearNewCompliters;

  public reject(dialogInfo: any, viewContainerRef: ViewContainerRef, companyReject: boolean): Observable<any> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.data = {
      type: "reject",
      companyReject: companyReject
    };
    config.viewContainerRef = viewContainerRef;

    const dialogRef = this.dialog.open(RejectAndConfirmDialogComponent, config);
    dialogRef.componentInstance.dialog = dialogInfo;
    return dialogRef.afterClosed();
  }

  public confirm(dialogInfo: any, viewContainerRef: ViewContainerRef, newDesign?: boolean): Observable<boolean> {
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.id = dialogInfo.id;
    config.viewContainerRef = viewContainerRef;
    if (newDesign) {
      config.panelClass = "ddd-dialog";
      config.backdropClass = "ddd-dialog-backdrop";
      config.autoFocus = false;
    } else {
      config.panelClass = ["cg-dialog", "middle"];
      config.backdropClass = "cg-dialog-backdrop";
      config.autoFocus = false;
    }
    config.data = {
      type: "confirm",
      templateName: dialogInfo.templateName,
      newDesign: newDesign
    };

    const dialogRef = this.dialog.open(RejectAndConfirmDialogComponent, config);
    dialogRef.componentInstance.dialog = dialogInfo;
    return dialogRef.afterClosed();
  }

  public confirmPageLeave(
    dialogInfo: any,
    viewContainerRef: ViewContainerRef,
    isDialog?: boolean
  ): Observable<boolean> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.viewContainerRef = viewContainerRef;
    config.data = {
      type: "confirmLeave",
      isDialog: isDialog
    };

    const dialogRef = this.dialog.open(RejectAndConfirmDialogComponent, config);
    dialogRef.componentInstance.dialog = dialogInfo;
    dialogRef.afterClosed();
    return dialogRef.afterClosed();
  }

  public confirmSentInvites(viewContainerRef: ViewContainerRef, data: any): Observable<boolean> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.viewContainerRef = viewContainerRef;
    config.data = {
      invitedColleagues: data,
      type: "confirmSentInvites"
    };
    const dialogRef = this.dialog.open(RejectAndConfirmDialogComponent, config);
    return dialogRef.afterClosed();
  }

  public showCompanySetupInfo(viewContainerRef: ViewContainerRef): Observable<boolean> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.viewContainerRef = viewContainerRef;
    config.data = {
      type: "companySetupInfo"
    };

    const dialogRef = this.dialog.open(RejectAndConfirmDialogComponent, config);
    return dialogRef.afterClosed();
  }

  public submitCompanySetupInfo(viewContainerRef: ViewContainerRef): Observable<boolean> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.viewContainerRef = viewContainerRef;
    config.data = {
      type: "submitCompanySetupInfo"
    };

    const dialogRef = this.dialog.open(RejectAndConfirmDialogComponent, config);
    return dialogRef.afterClosed();
  }

  public confirmAmendPriliminaryAnswers(viewContainerRef: ViewContainerRef): Observable<boolean> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.viewContainerRef = viewContainerRef;
    config.data = {
      type: "confirmAmendAnswers"
    };

    const dialogRef = this.dialog.open(RejectAndConfirmDialogComponent, config);
    return dialogRef.afterClosed();
  }
}
